<div class="ab-list-item-inner flex w-100 activity-type--new-user">
  <span class="ab-list-item__icon">
    <i class="icon fal fa-user-plus"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary" *ngIf="!item.target">
      <span class="actor">{{item?.user?.name}}</span> invited {{item.payload.user | fullName}} to the campaign as {{item.payload.user.role | propercase | aoran}}.
    </div>

    <!-- If there is a target (person) we can assume that a person was promoted to a user-->
    <div class="summary" *ngIf="item.target">
      <span class="actor">{{item?.user?.name}}</span> promoted <app-activity-target-link [target]="item.target">{{item?.target | fullName}}</app-activity-target-link> to {{item.payload.user.role | propercase | aoran}} user.
    </div>
  </div>
  <app-activity-event-timestamp [item]="item" class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
